import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: true,
});

export default echo;

// import { events } from './helpers';

// if (typeof SharedWorker === 'undefined') {
//   throw ('Your browser does not support SharedWorkers');
// }

// const { on, once, emit } = events();
// const worker = new SharedWorker('/scripts/workers/echo.worker.js');

// worker.port.onmessage = e => {
//   const { event, data } = e.data;
//   emit(event, data);
// }

// let socket_id;

// once('setup', data => {
//   socket_id = data.socket_id;
// });

// function socketId() {
//   return socket_id;
// }

// function dispatch(action, data) {
//   worker.port.postMessage({
//     action,
//     data,
//   });
// }

// function useEvent(channel, event, cb) {
//   dispatch('event', { channel, event });
//   on(`event.${channel}.${event}`, cb);
// }

// function useHook(channel, hook, cb) {
//   dispatch('hook', { channel, hook });
//   on(`hook.${channel}.${hook}`, cb);
// }

// function join(channel) {
//   const Channel = {
//     listen,
//     here,
//     joining,
//     leaving,
//   }

//   dispatch('channel', {
//     action: 'join',
//     channel,
//   });

//   const channelName = 'presence-' + channel;

//   function listen(event, cb) {
//     useEvent(channelName, event, cb);
//     return Channel;
//   }

//   function here(cb) {
//     useHook(channelName, 'here', cb);
//     return Channel;
//   }

//   function joining(cb) {
//     useHook(channelName, 'joining', cb);
//     return Channel;
//   }

//   function leaving(cb) {
//     useHook(channelName, 'leaving', cb);
//     return Channel;
//   }

//   return Channel;
// }

// export default {
//   socketId,
//   join,
//   on,
// };
